import React, { useRef } from "react";
import ReactToPrint from "react-to-print";
// import DataContext from './dataContext';

import { ComponentToPrint } from "./print";

const Example = ({ item , enteredOn, endingDate, itemName}) => {
  const componentRef = useRef();

  return (
    <div className="w-full">
      <ComponentToPrint ref={componentRef} item={item} enteredOn={enteredOn} endingDate={endingDate} itemName={itemName} />
      <div className="flex justify-center">
        <ReactToPrint
          trigger={() => (
            <button className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded">
              Print this out!
            </button>
          )}
          content={() => componentRef.current}
          // documentTitle="Stock Balences"
          pageStyle="print"
        />
      </div>
    </div>
  );
};

export default Example;
